import React, { useEffect, useRef, useState } from "react";
import SearchInput from "../../components/common/SearchInput/SearchInput";
import useClickOutside from "../../Hooks/useClickOutside";
import { useSelector, useDispatch } from "react-redux";
import RangeSlider from "../../components/common/InputField/RangeSlider";
import MainButton from "../../components/common/MainButton/MainButton";
import MapView from "../../components/common/Map/MapView";
import LocationAutocomplete from "../../components/common/InputField/LocationAutocomplete";
import Popup from "../../components/popup/Popup";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import { fetchServiceCategories } from "../../Redux/Slice/serviceCategoriesSlice";
import { useGraphQL } from "../../context/GraphQLProvider";
import {
  PUBLIC_CATEGORY_FILTER_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from "../Public/shared/publicLayoutSpec";

const Filters = () => {
  const dispatch = useDispatch();
  const graphqlService = useGraphQL();
  const [mainFilters, setMainFilters] = useState(false);
  const [mainSorting, setMainSorting] = useState(false);
  const [searchLocation, setSearchLocation] = useState(false);
  const [filters, setFilters] = useState(false);
  const [categories, setCategories] = useState(false);
  const [mcategories, setmCategories] = useState(false);
  const [msearchLocation, setmSearchLocation] = useState(false);
  const [mfilters, setmFilters] = useState(false);
  const [ShowCrossButton, setShowCrossButton] = useState(true);
  const [value, setValue] = useState("");
  
  // Use dynamic categories from Redux store
  const { categories: businessCategories } = useSelector((state) => state.serviceCategories);

  // Fetch categories if not available
  useEffect(() => {
    if (businessCategories.length === 0) {
      dispatch(fetchServiceCategories(graphqlService));
    }
  }, [dispatch, graphqlService, businessCategories.length]);

  useEffect(() => {
    if (msearchLocation || mfilters) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [msearchLocation, mfilters]);
  const ref = useRef(null);
  useClickOutside(ref, () => {
    setCategories(false);
    setSearchLocation(false);
    setFilters(false);
    setMainSorting(false);
  });
  return (
    <>
      <div className="flex justify-center h-[600px] xs:h-[650px] lg:h-[700px] xl:h-[800px] 2xl:h-[1000px]">
        <MapView />
      </div>
      <div
        className={`flex items-center justify-between mx-auto w-full ${PUBLIC_CATEGORY_FILTER_GAP_CLASS}`}
      >
        <div className="flex flex-col relative">
          <div>
            <MainButton
              variant={"outlinesmallbetween"}
              // className={"hidden sm:block"}
              onClick={() => setMainSorting(!mainSorting)}
            >
              Featured
              <i
                className={
                  mainSorting
                    ? "fi fi-rs-angle-up lg:text-[12px] cursor-pointer flex items-center"
                    : "fi fi-rs-angle-down lg:text-[12px] cursor-pointer flex items-center"
                }
              ></i>
            </MainButton>
          </div>
          {mainSorting && (
            <div
              ref={ref}
              className="flex flex-col rounded-xl w-[170px] sm:w-[180px] md:w-[190px] lg:w-54 py-5 absolute z-30 bg-white text-offblack mt-[70px]"
            >
              <button className="block px-4 py-2 hover:text-primaryblue w-full mt-1">
                <AuxiliaryText variant={"MenuDropdown"}>
                  Featured
                </AuxiliaryText>
              </button>
              {/* <button className="block px-4 py-2 hover:text-primaryblue w-full mt-1">
                <AuxiliaryText variant={"MenuDropdown"}>
                  Top rated
                </AuxiliaryText>
              </button> */}
              {/* <button className="block px-4 py-2  hover:text-primaryblue w-full mt-1">
                <AuxiliaryText variant={"MenuDropdown"}>
                  Verified
                </AuxiliaryText>
              </button> */}
              {/* <button className="block px-4 py-2  hover:text-primaryblue w-full mt-1">
                <AuxiliaryText variant={"MenuDropdown"}>
                  Licensed
                </AuxiliaryText>
              </button> */}
              <button className="block px-4 py-2  hover:text-primaryblue w-full mt-1">
                <AuxiliaryText variant={"MenuDropdown"}>
                  PRO only
                </AuxiliaryText>
              </button>
              <button className="block px-4 py-2  hover:text-primaryblue w-full mt-1">
                <AuxiliaryText variant={"MenuDropdown"}>
                  Recommended
                </AuxiliaryText>
              </button>
              <button className="block px-4 py-2  hover:text-primaryblue w-full mt-1">
                <AuxiliaryText variant={"MenuDropdown"}>Popular</AuxiliaryText>
              </button>
            </div>
          )}
        </div>
        <div>
          <MainButton
            variant={"outlinesmallbetween"}
            className={"hidden sm:block"}
            onClick={() => setMainFilters(!mainFilters)}
          >
            <i className={"fi fi-rs-bars-filter lg:text-[12px] flex items-center"}></i>
            Filters
          </MainButton>
          <MainButton
            variant={"outlinesmallbetween"}
            className={"sm:hidden"}
            onClick={() => setMainFilters(!mainFilters)}
          >
            <i className={"fi fi-rs-bars-filter lg:text-[12px] flex items-center"}></i>
            Filters
          </MainButton>
        </div>
      </div>
      {mainFilters && (
        <div
          className={`flex flex-col items-center justify-center xl:flex-row ${PUBLIC_HEADING_TO_CONTENT_CLASS}`}
        >
          <div className="xl:flex-1 w-full xl:mx-auto xl:w-fit">
            <SearchInput />
          </div>
          <div className="hidden xl:flex mt-5 md:mt-[23px] md:gap-x-5 flex-nowrap justify-center xl:justify-end w-full">
            <div className="relative">
              <MainButton
                variant={"outlinelargebetween"}
                onClick={() => {
                  setCategories(!categories);
                  setFilters(false);
                  setSearchLocation(false);
                }}
              >
                Categories
                <i
                  className={
                    categories
                      ? "fi fi-rs-angle-up lg:text-[12px] cursor-pointer flex items-center"
                      : "fi fi-rs-angle-down lg:text-[12px] cursor-pointer flex items-center"
                  }
                ></i>
              </MainButton>
              {categories && (
                <div
                  ref={ref}
                  className="p-5 md:pt-10 md:pl-10 md:pr-5 md:pb-10 rounded-xl absolute z-20 bg-white text-offblack mt-3 w-[550px] "
                >
                  <form className="mx-auto">
                    <div className="mb-5">
                      <AuxiliaryText variant={"MenuDropdown"} className={"font-semibold"}>
                        All categories
                      </AuxiliaryText>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-2 mx-2 gap-x-5">
                      {React.Children.toArray(
                        businessCategories?.map((e, index) => {
                          return (
                            <div key={index} className="flex items-center mb-2">
                              <label
                                className="relative flex items-center rounded-full cursor-pointer mr-3"
                                htmlFor={`category-${e.id}`}
                              >
                                <input
                                  type="checkbox"
                                  className={`before:content[''] peer relative size-4 cursor-pointer appearance-none rounded-[4px] border border-mediumgray transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-primaryblue checked:bg-primaryblue checked:before:bg-primaryblue`}
                                  id={`category-${e.id}`}
                                />
                                <span className={`absolute text-white transition-opacity opacity-0 pointer-events-none top-[40%] left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100`}>
                                  <i className={`fi fi-rs-check text-[10px]`}></i>
                                </span>
                              </label>
                              <AuxiliaryText
                                variant={"SubMenuDropdown"}
                                className={"text-offblack"}
                              >
                                {e?.name}
                              </AuxiliaryText>
                            </div>
                          );
                        })
                      )}
                    </div>
                    <div className="flex justify-center mt-10">
                      <MainButton variant={"large"}>Apply</MainButton>
                    </div>
                  </form>
                </div>
              )}
            </div>
            <div className="relative">
              <MainButton
                className={"mx-3 md:mx-0"}
                variant={"outlinemediumbetween"}
                onClick={() => {
                  setSearchLocation(!searchLocation);
                  setCategories(false);
                  setFilters(false);
                }}
              >
                Location
                <i
                  className={
                    searchLocation
                      ? "fi fi-rs-angle-up lg:text-[12px] cursor-pointer flex items-center"
                      : "fi fi-rs-angle-down lg:text-[12px] cursor-pointer flex items-center"
                  }
                ></i>
              </MainButton>
              {searchLocation && (
                <div
                  ref={ref}
                  className="px-6 pt-8 pb-4 rounded-xl w-full xl:w-[348px] h-[408px] absolute z-20 bg-white mt-3"
                >
                  <form className="mx-auto">
                    <div>
                      <LocationAutocomplete
                        variant={"general"}
                        fullWidth
                        label={"Suburb"}
                        placeholder={"Start typing your suburb or postcode"}
                        value={value}
                        onChange={(value) => setValue(value)}
                      />
                    </div>
                    <div className="my-8">
                      <AuxiliaryText variant={"FieldLabel"}>
                        Distance
                      </AuxiliaryText>
                    </div>
                    <RangeSlider />
                    <div className="flex justify-center mt-[82px]">
                      <MainButton variant={"small"}>Apply</MainButton>
                    </div>
                  </form>
                </div>
              )}
            </div>
            <div className="relative">
              <MainButton
                variant={"outlinemediumbetween"}
                onClick={() => {
                  setFilters(!filters);
                  setSearchLocation(false);
                  setCategories(false);
                }}
              >
                Timeframe
                <i
                  className={
                    filters
                      ? "fi fi-rs-angle-up lg:text-[12px] cursor-pointer flex items-center"
                      : "fi fi-rs-angle-down lg:text-[12px] cursor-pointer flex items-center"
                  }
                ></i>
              </MainButton>
              {filters && (
                <>
                  <div
                    ref={ref}
                    className="flex flex-col rounded-xl w-44 py-5 absolute right-[5%] 2xl:right-auto z-20 bg-white text-offblack mt-3"
                  >
                    <button
                      onClick={() => setFilters(false)}
                      className="block px-4 py-2 hover:text-primaryblue w-full mt-1"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Recent
                      </AuxiliaryText>
                    </button>
                    <button
                      onClick={() => setFilters(false)}
                      className="block px-4 py-2 hover:text-primaryblue w-full mt-1"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        This Week
                      </AuxiliaryText>
                    </button>
                    {/* <button
                      onClick={() => setFilters(false)}
                      className="block px-4 py-2 hover:text-primaryblue w-full mt-1"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Past Week
                      </AuxiliaryText>
                    </button> */}
                    <button
                      onClick={() => setFilters(false)}
                      className="block px-4 py-2 hover:text-primaryblue w-full mt-1"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        This Month
                      </AuxiliaryText>
                    </button>
                    {/* <button
                      onClick={() => setFilters(false)}
                      className="block px-4 py-2 hover:text-primaryblue w-full mt-1"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        Past Month
                      </AuxiliaryText>
                    </button> */}
                    <button
                      onClick={() => setFilters(false)}
                      className="block px-4 py-2 hover:text-primaryblue w-full mt-1"
                    >
                      <AuxiliaryText variant={"MenuDropdown"}>
                        All time
                      </AuxiliaryText>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="xl:hidden w-full">
            <div className="flex items-center justify-center gap-4 mt-5 w-full">
              <div>
                <MainButton
                  variant={"outlinelargebetween"}
                  className={"hidden sm:block"}
                  onClick={() => {
                    setmCategories(!mcategories);
                  }}
                >
                  Categories
                  <i
                    className={
                      mcategories
                        ? "fi fi-rs-angle-up lg:text-[12px] cursor-pointer flex items-center"
                        : "fi fi-rs-angle-down lg:text-[12px] cursor-pointer flex items-center"
                    }
                  ></i>
                </MainButton>
                <MainButton
                  variant={"outlinemedium"}
                  className={"sm:hidden"}
                  onClick={() => {
                    setmCategories(!mcategories);
                  }}
                >
                  Categories
                  {/* <i
                    className={
                      mcategories
                        ? "fi fi-rs-angle-up text-xs lg:text-sm cursor-pointer"
                        : "fi fi-rs-angle-down text-xs lg:text-sm cursor-pointer"
                    }
                  ></i> */}
                </MainButton>
              </div>
              <div>
                <MainButton
                  className={"hidden sm:block sm:mx-3 md:mx-0"}
                  variant={"outlinelargebetween"}
                  onClick={() => {
                    setmSearchLocation(!msearchLocation);
                  }}
                >
                  Location
                  <i
                    className={
                      msearchLocation
                        ? "fi fi-rs-angle-up lg:text-[12px] cursor-pointer flex items-center"
                        : "fi fi-rs-angle-down lg:text-[12px] cursor-pointer flex items-center"
                    }
                  ></i>
                </MainButton>
                <MainButton
                  className={"sm:hidden sm:mx-3 md:mx-0"}
                  variant={"outlinemedium"}
                  onClick={() => {
                    setmSearchLocation(!msearchLocation);
                  }}
                >
                  Location
                  {/* <i
                    className={
                      msearchLocation
                        ? "fi fi-rs-angle-up text-xs lg:text-sm cursor-pointer"
                        : "fi fi-rs-angle-down text-xs lg:text-sm cursor-pointer"
                    }
                  ></i> */}
                </MainButton>
              </div>
              <div>
                <MainButton
                  variant={"outlinemediumbetween"}
                  className={"hidden sm:block"}
                  ref={ref}
                  onClick={() => {
                    setmFilters(!mfilters);
                  }}
                >
                  Sort
                  <i
                    className={
                      mfilters
                        ? "fi fi-rs-angle-up lg:text-[12px] cursor-pointer flex items-center"
                        : "fi fi-rs-angle-down lg:text-[12px] cursor-pointer flex items-center"
                    }
                  ></i>
                </MainButton>
                <MainButton
                  variant={"outlinesmall"}
                  className={"sm:hidden"}
                  ref={ref}
                  onClick={() => {
                    setmFilters(!mfilters);
                  }}
                >
                  Sort
                  {/* <i
                    className={
                      mfilters
                        ? "fi fi-rs-angle-up text-xs lg:text-sm cursor-pointer"
                        : "fi fi-rs-angle-down text-xs lg:text-sm cursor-pointer"
                    }
                  ></i> */}
                </MainButton>
              </div>
            </div>
            <div>
              {mcategories && (
                <>
                  <Popup
                    setTrigger={() => setmCategories(false)}
                    ShowCrossButton={ShowCrossButton}
                    className={"bg-white"}
                  >
                    <>
                      <form className="mt-10 sm:mt-5 mx-[5%] bg-white pb-40 overflow-auto h-screen">
                        <div className="text-center">
                          <AuxiliaryText variant={"MenuDropdown"} className={"font-semibold"}>
                            All categories
                          </AuxiliaryText>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-2 w-full gap-x-5 overflow-auto h-[70%] mt-10 sm:mt-5 hidden-scrollbar px-1">
                          {React.Children.toArray(
                            businessCategories?.map((e, index) => {
                              return (
                                <div key={index} className="mb-[0.125rem] flex items-center min-h-[1.5rem]">
                                  <label
                                    className="relative flex items-center rounded-full cursor-pointer mr-3"
                                    htmlFor={`mobile-category-${e.id}`}
                                  >
                                    <input
                                      type="checkbox"
                                      className={`before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-[4px] border border-mediumgray transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-primaryblue checked:bg-primaryblue checked:before:bg-primaryblue`}
                                      id={`mobile-category-${e.id}`}
                                    />
                                    <span className={`absolute text-white transition-opacity opacity-0 pointer-events-none top-[40%] left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100`}>
                                      <i className={`fi fi-rs-check text-[10px]`}></i>
                                    </span>
                                  </label>

                                  <AuxiliaryText variant={"SubMenuDropdown"}>
                                    {e?.name}
                                  </AuxiliaryText>
                                </div>
                              );
                            })
                          )}
                        </div>
                        <div className="flex justify-center mt-10">
                          <MainButton variant={"extralarge"}>Apply</MainButton>
                        </div>
                      </form>
                    </>
                  </Popup>
                </>
              )}
              {msearchLocation && (
                <>
                  <Popup
                    setTrigger={() => setmSearchLocation(false)}
                    ShowCrossButton={ShowCrossButton}
                    className={"bg-white"}
                  >
                    <>
                      <form className="mt-20 sm:mt-5 mx-[5%] bg-white sm:overflow-auto sm:h-[500px] pb-[500px]">
                        <div className="max-w-[350px] sm:max-h-[200px] mx-auto">
                          <div className="relative mt-5">
                            <LocationAutocomplete
                              variant={"general"}
                              fullWidth
                              label={"Suburb"}
                              placeholder={"Start typing your suburb or postcode"}
                              className={"bg-pastalblue"}
                              value={value}
                              onChange={(value) => setValue(value)}
                            />
                          </div>
                          <div className="my-8">
                            <AuxiliaryText variant={"FieldLabel"}>
                              Distance
                            </AuxiliaryText>
                          </div>
                          <RangeSlider />
                          <div className="flex justify-center mt-[82px]">
                            <MainButton variant={"extralarge"}>Apply</MainButton>
                          </div>
                        </div>
                      </form>
                    </>
                  </Popup>
                </>
              )}
              {mfilters && (
                <>
                  <Popup
                    setTrigger={() => setmFilters(false)}
                    ShowCrossButton={ShowCrossButton}
                    className={"bg-white"}
                  >
                    <>
                      <form className="mt-20 sm:mt-5 mx-[5%] bg-white sm:overflow-auto sm:h-[500px] pb-[500px]">
                        <div className="max-w-[350px] mx-auto">
                          <div className="flex flex-col rounded-xl w-60 py-5 text-offblack mx-auto">
                            <button className="block px-4 py-2 hover:text-primaryblue w-full">
                              <AuxiliaryText variant={"MenuDropdown"}>
                                now
                              </AuxiliaryText>
                            </button>
                            <button className="block px-4 py-2 hover:text-primaryblue w-full mt-1">
                              <AuxiliaryText variant={"MenuDropdown"}>
                                This Week
                              </AuxiliaryText>
                            </button>
                            <button className="block px-4 py-2 hover:text-primaryblue w-full mt-1">
                              <AuxiliaryText variant={"MenuDropdown"}>
                                Past Week
                              </AuxiliaryText>
                            </button>
                            <button className="block px-4 py-2 hover:text-primaryblue w-full mt-1">
                              <AuxiliaryText variant={"MenuDropdown"}>
                                This Month
                              </AuxiliaryText>
                            </button>
                            <button className="block px-4 py-2 hover:text-primaryblue w-full mt-1">
                              <AuxiliaryText variant={"MenuDropdown"}>
                                Past Month
                              </AuxiliaryText>
                            </button>
                            <button className="block px-4 py-2 hover:text-primaryblue w-full mt-1">
                              <AuxiliaryText variant={"MenuDropdown"}>
                                All Time
                              </AuxiliaryText>
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  </Popup>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Filters;
